module.exports = __webpack_public_path__ + "img/云指课堂logo.a27034e8.png";